export default __webpack_public_path__ + "static/media/check.67fb2759.svg";